import React  from 'react';
import { X, FileText } from 'lucide-react';

const DocumentPreviewModal = ({ isOpen, onClose, fileUrl }) => {
  if (!isOpen) return null;

  const fileExtension = fileUrl.split('.').pop().toLowerCase();
  const isPdf = fileExtension === 'pdf';
  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        {/* Close Button */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 z-60 text-gray-600 hover:text-gray-900"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Document Preview */}
        <div className="flex-grow overflow-auto p-4">
          {isPdf ? (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe 
              src={`${fileUrl}#toolbar=0`} 
              width="100%" 
              height="600" 
              className="border-none"
            />
          ) : isImage ? (
            <img 
              src={fileUrl} 
              alt="Document Preview" 
              className="max-w-full max-h-[80vh] mx-auto object-contain"
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full">
              <FileText className="w-16 h-16 text-gray-400 mb-4" />
              <p className="text-gray-600">Unsupported file type</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentPreviewModal;